import { useContext, useEffect, useRef, useState } from "react";
import $ from "jquery";
import { useNavigate, useParams } from "react-router-dom";
import { GlobalContext } from "../GlobalContext";
import { useAuth } from "../AuthContext";
import { useNoteAlert } from "../pleaseNote";
import { useGlobalFunction } from "../GlobalFunctionContext";
import { useCheckPoNumberRules } from "./useCheckPONumberRules";
import { axiosInstance } from "../../axios/axiosInstance";
import {
  isNumeric,
  isValidArray,
  showCardDetails,
  smsNumberChangeClick,
  validateMonthYear,
} from "../../Layout/Common/common";
import { ChangeOfAddressType, PONUMBER_ALLOW_DUPLICATE, SHIPPING_METHOD } from "../../constants";
import { PAGES } from "../../routeConfig";
import { redirectToTill } from "./tillRedirect";

export const usePayNow = () => {
  const submittingRef = useRef(false);
  const [paybuttonDisabled, setPaybuttonDisabled] = useState(true);
  const [smsNumberCancelClicked, setSmsNumberCancelClicked] = useState(false);
  const { orderId } = useParams();
  const globalcontext = useContext(GlobalContext);
  const {
    poNumber,
    selectedPaymentType,
    setSelectedPaymentType,
    deliveryMethod,
    orderCommands,
    shippingMode,
    selectedCard,
    promoCode,
    isSubmitOrder,
    newCardSave,
    smsNumber,
    OrderId,
    smsNotificationCancelClicked,
    setRefreshable,
  } = globalcontext;

  const { userId } = useAuth();
  const { submitOrderMailSend } = useGlobalFunction();
  const { showNoteAlert, showDialogAlert, showFlashScreen, hideNoteAlert } = useNoteAlert();
  const checkPoNumberRules = useCheckPoNumberRules();
  const history = useNavigate();

  const captureCheckoutUi = () => ({
    poNumber,
    orderCommands,
    deliveryMethod,
    shipServiceKey: globalcontext.shipService ? globalcontext.shipService.key : null,
    selectedPaymentType,
    selectedCardUuid: selectedCard ? selectedCard.cardUuid : null,
    newCardSave,
    newcardName: globalcontext.newcardName,
    newcardExp: globalcontext.newcardExp,
    promoCode,
    smsNumber,
    smsNotificationCancelClicked: smsNotificationCancelClicked ? smsNotificationCancelClicked.current : null,
    addressType: globalcontext.addressType,
    selectedAddressId: globalcontext.selectedAddressId,
    addressOrderId: globalcontext.addressOrderId,
    newAddress: globalcontext.newAddress,
    shippingAddress: globalcontext.addressType != null ? globalcontext.shippingAddress : null,
    changeAddressClicked: globalcontext.changeAddressClicked,
    orderCommentsOpen: $("#purchase-order-cmt1").is(":visible"),
    scrollY: window.scrollY,
  });

  const handOffToTill = (redirectUrl) => {
    redirectToTill(redirectUrl);
  };

  useEffect(() => {
    setSmsNumberCancelClicked(smsNotificationCancelClicked.current ?? false);
  }, [smsNotificationCancelClicked.current]);

  useEffect(() => {
    const onPageShow = (event) => {
      if (event.persisted) submittingRef.current = false;
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  useEffect(() => {
    setPaybuttonDisabled(true);
    if (deliveryMethod != null) {
      if (String(deliveryMethod).includes(SHIPPING_METHOD[1])) {
        $("#purchase-order-cmt1").show("slow");
        if (shippingMode != null) setPaybuttonDisabled(false);
        else return;
      }
    }
    setPaybuttonDisabled(false);
    if (!selectedPaymentType && isSubmitOrder == false) {
      setPaybuttonDisabled(true);
    }
    if (selectedPaymentType == "MYWALLET" && !selectedCard) {
      setPaybuttonDisabled(true);
    }
  }, [selectedPaymentType, isSubmitOrder, deliveryMethod, shippingMode]);

  const getCardUuid = () => {
    if (selectedCard && selectedPaymentType == "MYWALLET") {
      return selectedCard.cardUuid;
    }
  };

  const ProcessPayment = (trntoken) => {
    var params = {
      userId: String(userId),
      orderId: String(orderId ?? ""),
      mobileNumber: globalcontext.smsNumber ?? "",
      amount: globalcontext.netAmount,
      shipNotes: orderCommands,
      shippingAddress: globalcontext.shippingAddress,
      shipcode: globalcontext.shippingCode,
      shipcost: globalcontext.shippingCost,
      orderCommands: orderCommands,
      transaction_token: trntoken,
      addressType: "",
      signRequired: false,
      isSaveCard: newCardSave,
      uuid: getCardUuid(),
      paymentMode: selectedPaymentType || "ORDER SUBMIT",
      cardType: selectedPaymentType,
      grossAmount: String(globalcontext.CartItem.totalcost),
      totalTax: globalcontext.totalTax,
      deliveryMethod: deliveryMethod,
      shippingService: shippingMode || deliveryMethod,
      purchaseOrderNumber: poNumber,
      promoCode: promoCode,
      returnPath: window.location.pathname,
      checkoutState: JSON.stringify(captureCheckoutUi()),
    };

    if (selectedPaymentType == "MYWALLET" || selectedPaymentType == "NEWCARD") {
      params.paymentMode = "TI";
    }

    if (globalcontext.IsInterNational == false) {
      if (params.paymentMode.toUpperCase() != "TI") {
        globalcontext.setUuid("0");
      }

      if (
        globalcontext.addressType == ChangeOfAddressType.changeOfAddress ||
        globalcontext.addressType == ChangeOfAddressType.dropShippment
      ) {
        if (globalcontext.addressType == ChangeOfAddressType.changeOfAddress) params.addressType = "A";
        if (globalcontext.addressType == ChangeOfAddressType.dropShippment) params.addressType = "D";
        if (globalcontext.shippingAddress) {
          params.shippingAddress = globalcontext.shippingAddress;
          params.signRequired = globalcontext.shippingAddress.signatureRequired;
        }
      }
    }
    if (submittingRef.current) return;
    submittingRef.current = true;
    setRefreshable(false);
    showFlashScreen({
      messages: ["Processing your order, please wait…", "Please do not refresh or close this window."],
    });
    axiosInstance
      .post("Shipping/PaymentProcessNew", params)
      .then((response) => {
        if (response.data != "" && response.data != null) {
          showFlashScreen(false);
          if (response.data.Status == "Success") {
            if (params.paymentMode == "TI") {
              showFlashScreen({
                messages: ["Taking you to the secure payment page…", "Please do not refresh or close this window."],
              });
              handOffToTill(response.data.RedirectTo);
            } else {
              submittingRef.current = false;
              submitOrderMailSend(response.data.orderid);
              history("/BillInfo/" + response.data.RedirectTo);
            }
          } else {
            submittingRef.current = false;
            setRefreshable(true);
            if (response.data.Status == "Error01") {
              history(PAGES.ORDER_DETAIL);
            } else if (response.data.Status == "PAYMENT_PROCESS") {
              showNoteAlert("Payment is being processed for this order. Please wait for a moment and try again.");
            } else if (response.data.Status == "ORDER_STATUS") {
              showNoteAlert("Your order status has been changed. Please check and try again.");
              window.location.reload();
            } else {
              showNoteAlert("Payment Process Failed. Please try again.");
            }
            showFlashScreen(false);
          }
        } else {
          submittingRef.current = false;
          setRefreshable(true);
        }
      })
      .catch((error) => {
        submittingRef.current = false;
        setRefreshable(true);
        showFlashScreen(false);
      });
  };

  const GenerateToken = () => {
    var validation = true;
    var cardName = globalcontext.newcardName;
    var cardExp = globalcontext.newcardExp;

    if (isNumeric(cardName) == false) {
      showFlashScreen(false);
      $("#newcardNameError").css("display", "block");
      $("#cardName").focus();
      validation = false;
    }
    if (!validateMonthYear(cardExp)) {
      showFlashScreen(false);
      $("#newcardExpError").css("display", "block");
      if (validation == false) $("#cardExp").focus();
      validation = false;
    }
    if (validation) {
      var splitval = cardExp.split("/");
      var data = {
        card_holder: cardName,
        month: splitval[0],
        year: "20" + splitval[1],
      };
      window.till.tokenize(
        data,
        function (token, cardData) {
          ProcessPayment(token);
        },
        function (errors) {
          if (errors) {
            if (isValidArray(errors)) {
              var errmsg = errors[0].message;
              if (errmsg) {
                showNoteAlert(errmsg);
              } else {
                showNoteAlert("Payment process failed. Please try again.");
              }
            }
          }
          showFlashScreen(false);
        },
      );
    } else {
      showNoteAlert("Please fill in the mandatory fields and try again.");
      showFlashScreen(false);
    }
  };

  const PayNow = () => {
    showFlashScreen(true);
    if (selectedPaymentType == "NEWCARD") {
      GenerateToken();
    } else {
      ProcessPayment("");
    }
  };

  const checkOrderNumber = (onValidated) => {
    const porules = checkPoNumberRules(poNumber, orderCommands);
    if (porules == false) return false;
    if (porules == true) {
      showFlashScreen(true);
      if (poNumber) {
        axiosInstance
          .post("Shipping/CheckOrderId", {
            userid: String(userId),
            orderid: String(orderId ?? OrderId),
            purchaseOrderNumber: String(poNumber),
          })
          .then((response) => {
            if (response.data != null) {
              var result = parseInt(response.data);
              if (result == 2) {
                showDialogAlert({
                  content: PONUMBER_ALLOW_DUPLICATE.content,
                  title: PONUMBER_ALLOW_DUPLICATE.title,
                  primaryBtn: {
                    caption: "Enter New Order No",
                    onClick: () => {
                      $("#poNumbertextbox").focus();
                    },
                  },
                  scondaryBtn: {
                    caption: "Submit with duplicate No",
                    onClick: () => onValidated(),
                  },
                });
              } else if (result == 0) {
                showNoteAlert(PONUMBER_ALLOW_DUPLICATE.content, PONUMBER_ALLOW_DUPLICATE.title, false, () => {
                  $("#poNumbertextbox").focus();
                });
              } else {
                onValidated();
              }
            }
          })
          .catch((error) => {
            showNoteAlert("Something went wrong. Please try again.");
          });
      } else {
        onValidated();
      }
    }
  };

  const runValidationsThen = (onValidated) => {
    if (String(deliveryMethod).includes(SHIPPING_METHOD[2]) && !smsNumber && smsNumberCancelClicked == false) {
      showDialogAlert({
        content: "Please provide a mobile number to receive SMS notification or proceed without SMS notification.",
        title: "SMS Notification Not Provided",
        primaryBtn: {
          caption: "Provide Mobile Number",
          onClick: () => smsNumberChangeClick(),
        },
        scondaryBtn: {
          caption: "Proceed without SMS",
          onClick: () => {
            setSmsNumberCancelClicked(true);
            checkOrderNumber(onValidated);
          },
        },
      });
    } else {
      checkOrderNumber(onValidated);
    }
  };

  // Same readiness checks that the disabled button used; now run on click so we can
  // tell the user exactly what's missing via a popup instead of silently disabling.
  const getPayValidationError = () => {
    if (deliveryMethod != null && String(deliveryMethod).includes(SHIPPING_METHOD[1]) && shippingMode == null) {
      return "Please select a shipping service before proceeding.";
    }
    if (!selectedPaymentType && isSubmitOrder == false) {
      return "Please select a payment method before proceeding.";
    }
    if (selectedPaymentType == "MYWALLET" && !selectedCard) {
      return "Please select a card from your wallet before proceeding.";
    }
    return null;
  };

  const handlePayNowClick = () => {
    const validationError = getPayValidationError();
    if (validationError) {
      showNoteAlert(validationError, "Shipping Service Required");
      return;
    }
    runValidationsThen(() => PayNow());
  };

  const handleWalletPayClick = (onValidated) => {
    const validationError = getPayValidationError();
    if (validationError) {
      showNoteAlert(validationError);
      return;
    }
    runValidationsThen(() => {
      if (typeof onValidated === "function") onValidated();
    });
  };

  const paymentDeclineFunction = () => {
    setSelectedPaymentType("NEWCARD");
    $("#newCardPayment").click();
    $(".card-details-list1").show("slow");
    $(".acc-details-list1").hide("slow");
    showCardDetails();
    hideNoteAlert();
  };

  return {
    handlePayNowClick,
    handleWalletPayClick,
    processPayment: ProcessPayment,
    paybuttonDisabled,
    paymentDeclineFunction,
  };
};
